module.exports = __webpack_public_path__ + "static/media/FeedTime_ios_3_preview.79570f23.jpg";